import React, { useMemo, forwardRef, useRef, useImperativeHandle } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

// series: array of { label: string, value: number }
const AvgValueChart = forwardRef(function AvgValueChart({ series = [], title = 'Valor promedio por tiempo' }, ref) {
  const chartRef = useRef(null);

  // Exponer método para obtener la imagen en base64 desde el chart
  useImperativeHandle(ref, () => ({
    toBase64Image: () => {
      try {
        return chartRef.current ? chartRef.current.toBase64Image() : null;
      } catch (err) {
        return null;
      }
    }
  }));

  const data = useMemo(() => {
    const labels = series.map((s) => s.label);
    const values = series.map((s) => s.value);
    return {
      labels,
      datasets: [
        {
          label: title,
          data: values,
          fill: false,
          borderColor: '#2962ff',
          backgroundColor: '#2962ff',
          tension: 0.2,
          pointRadius: 3,
        },
      ],
    };
  }, [series, title]);

  const options = useMemo(() => ({
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      title: { display: false, text: title },
      tooltip: { mode: 'index', intersect: false },
    },
    interaction: { mode: 'nearest', axis: 'x', intersect: false },
    scales: {
      x: {
        display: true,
        title: { display: false }
      },
      y: {
        display: true,
        ticks: { callback: (v) => new Intl.NumberFormat('es-CO').format(v) }
      }
    }
  }), [title]);

  if (!series || series.length === 0) return null;

  return (
    <div className="avg-value-chart" style={{ height: 260 }}>
      <Line ref={chartRef} data={data} options={options} />
    </div>
  );
});

export default AvgValueChart;
